(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, EnigmaRotor);

	// Constructor
	function EnigmaRotor(el, wheelData) {
		this.el = $(el);
		this.init(wheelData)
	}


	EnigmaRotor.prototype.init = function (wheelData) {

		console.log(wheelData);

		// Create numbers labels
		for (var i = 0; i < wheelData.length; i++) {

			// Make them two-digits
			// var number = (wheelData[i] - this.charToASCI('A')).toString();
			// var number = (wheelData.length - i).toString();
			var number = (i + 1).toString();
			while (number.toString().length < 2) {
				number = "0" + number.toString();
			}

			// Create DOM element
			this.el.append("<li class='tick'><span>" + number + "</span></li>");
		}

		// Init slick
		this.el.slick({
			vertical: true,
			swipe: false,
			touchMove: false,
			slidesToShow: 7,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: true,
			centerMode: true,
			accessibility: false,
			draggable: false,
			waitForAnimate: false,
			centerPadding: "93px",
		});
	};

	EnigmaRotor.prototype.tick = function () {
		this.el.slick("slickNext");
	};

	EnigmaRotor.prototype.untick = function () {
		this.el.slick("slickPrev");
	};

	EnigmaRotor.prototype.reset = function (destinationScreen) {
		this.el.slick("slickGoTo", 0);
	}

	EnigmaRotor.prototype.charToASCI = function (char) {
		return char.toString().charCodeAt(0);
	};


	// Expose Timeline
	window.EnigmaRotor = EnigmaRotor;

})(jQuery, Promise);